import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import TitleBar from '../utils/TitleBar.js';
import ReactECharts from 'echarts-for-react';

const opt = {
    backgroundColor: 'white',
    xAxis: {
        show: false,
    },
    yAxis: {
        show: false,
    },
    series: [
        {
            name: 'CellVoltage',
            type: 'gauge',
            splitNumber: 0,
            axisLine: {            // 坐标轴线
                lineStyle: {       // 属性lineStyle控制线条样式
                    color: [[0.4, '#1B8AC5'], [1, '#f0f0f0']],
                    width: 8,
                }
            },
            axisTick: {
                show: false,
            },
            axisLabel: {
                show: false,
            },
            splitLine: {
                show: false,
            },
            pointer: {           // 分隔线
                width: 0,
            },
            title: {
                show: false,
            },
            detail: {
                offsetCenter: [0, 0],       // x, y，单位px
                textStyle: {       // 其余属性默认使用全局文本样式
                    fontWeight: 'bold',
                    color: 'black',
                    fontSize: 12,
                    lineHeight: 14,
                },
                show: true,
                formatter: (v) => {
                    const value = typeof v === 'number' && Number.isFinite(v) ? v : 0;
                    return value.toFixed(1) + "V";
                }
            },
            data: [{value: 0, name: 'V'}]
        },
    ],
};

function CellVoltage (props) {
    const { t } = useTranslation();
    const { data} = props;

    const chart = useRef(null);

    if (opt.series) {
        let s = opt.series[0];
        const minCellVoltageRaw = data && typeof data["MinCellVoltage"] === 'number' ? data["MinCellVoltage"] : null;
        const value = minCellVoltageRaw !== null ? (minCellVoltageRaw / 1000) : 0;
        s.data = [{...s.data[0], value: value}];
        s.axisLine.lineStyle.color[0][0] = Math.min(Math.abs(value)/6, 1);
    }

    useEffect(() => {
        const instance = chart.current ? chart.current.getEchartsInstance() : null;
        if (instance) {
            instance.setOption(opt);
        }
    }, [data])

    return (
        <div style={{
            padding: '10px 15px',
            height: '100%',
            // display: 'flex',
            // flexDirection: 'column'
        }}>
            <TitleBar title={t('Cell Voltage')} data={data} />
            <div style={{ marginTop: '8px' }}>
                <ReactECharts ref={chart} option={opt} style={{height: '100px'}} />
            </div>
            <div style={{width: '100%', backgroundColor: '#f0f0f0', borderRadius: '10px', padding: '4px 8px', fontSize: '12px', margin: '8px 0 4px'}}>
                {t('min_cell_voltage', {
                    voltage: (data && typeof data["MinCellVoltage"] === 'number') ? (data["MinCellVoltage"]/1000).toFixed(3): '0.000',
                    cluster: (data && (data["MinCVCluster"] || data["MinCVCluster"] === 0)) ? data["MinCVCluster"] : '0',
                    packet: (data && (data["MinCVPacket"] || data["MinCVPacket"] === 0)) ? data["MinCVPacket"] : '0',
                    index: (data && (data["MinCVIndex"] || data["MinCVIndex"] === 0)) ? data["MinCVIndex"] : '0'
                })}
            </div>
            <div style={{width: '100%', backgroundColor: '#f0f0f0', borderRadius: '10px', padding: '4px 8px', fontSize: '12px'}}>
                {t('max_cell_voltage', {
                    voltage: (data && typeof data["MaxCellVoltage"] === 'number') ? (data["MaxCellVoltage"]/1000).toFixed(3): '0.000',
                    cluster: (data && (data["MaxCVCluster"] || data["MaxCVCluster"] === 0)) ? data["MaxCVCluster"] : '0',
                    packet: (data && (data["MaxCVPacket"] || data["MaxCVPacket"] === 0)) ? data["MaxCVPacket"] : '0',
                    index: (data && (data["MaxCVIndex"] || data["MaxCVIndex"] === 0)) ? data["MaxCVIndex"] : '0'
                })}
            </div>
        </div>
    );
}

export default CellVoltage;